import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useRefs() {
  const [refs, setRefs] = useState({ programs: [], roleCategories: [], roleLevels: [] });

  const load = () => {
    Promise.all([
      api.get("/programs"), api.get("/role-categories"), api.get("/role-levels"),
    ]).then(([p, rc, rl]) => setRefs({ programs: p.data, roleCategories: rc.data, roleLevels: rl.data })).catch(() => {});
  };

  useEffect(load, []);

  const nameOf = (list, id) => list.find((x) => x.id === id)?.name || id;
  return {
    ...refs,
    managedPrograms: refs.programs.filter((p) => p.managed),
    reload: load,
    programName: (id) => nameOf(refs.programs, id),
    rcName: (id) => nameOf(refs.roleCategories, id),
    rlName: (id) => nameOf(refs.roleLevels, id),
  };
}
